import { TextField, useRecordContext } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';

import { OrderShowLogsDelayField } from './OrdersShowLogsDelayField/OrdersShowLogsDelayField';
import { OrdersShowLogsStatusField } from './OrdersShowLogsStatusField/OrdersShowLogsStatusField';

export const OrdersShowLogsResponseFields = (): JSX.Element | null => {
  const record = useRecordContext();
  const responseStatus = record?.responseData?.statusCode;

  return (
    <Stack alignItems="center" direction="row" gap="8px">
      {!!responseStatus && <OrdersShowLogsStatusField />}
      <OrderShowLogsDelayField />
      <TextField source="requestUrl" sx={{ maxWidth: '800px' }} />
    </Stack>
  );
};
